// removed by extract-text-webpack-plugin
module.exports = {"admin":"admin","popover-body":"popover-body"};


//////////////////
// WEBPACK FOOTER
// ./src/components/grids/ViewUsersGrid/subComponents/PopConfirm/PopConfirm.scss
// module id = 5646
// module chunks = 1